module.exports = {
  layouts:
    [
      //Streams
      {
        name: 'Carousel - Portrait',
        description: 'A carousel scroll of Streams with portrait thumbnails. Displays the most number of Streams per screen when compared to Carousel - Landscape.',
        note: 'You can add as many Streams as you’d like to in this layout.',
        detailImage: "",
        icon: "",
        dimensions: '236 * 315 px',
        data: {
          columns: [{
            width: 2,
            section: {
              title: 'Section 1',
              contents: [],
              type: 'carousel_portrait',
              entityType: 'STREAM',
              layoutStyle: 'CAROUSEL',
              cardStyle: 'LARGE',
              smartFilter: 'RECENTLY_VIEWED_STREAMS'
            }
          }]
        }
      },
      {
        name: 'Carousel - Landscape',
        entityType: 'STREAM',
        description: 'A carousel scroll of Streams with landscape thumbnails. Highlights the thumbnail designs for a visually rich experience.',
        note: 'You can add as many Streams as you’d like to in this layout.',
        detailImage: "",
        icon: "",
        dimensions: '236 * 102 px',
        data: {
          columns: [{
            width: 2,
            section: {
              title: "Section 1",
              entityType: 'STREAM',
              contents: [],
              type: 'carousel_landscape',
              layoutStyle: 'CAROUSEL',
              cardStyle: 'SMALL',
              smartFilter: 'RECENTLY_VIEWED_STREAMS'
            }
          }]
        }
      },

      //Collections
      {
        name: 'Carousel',
        description: 'A carousel scroll of Collections with landscape thumbnails. Highlights the thumbnail designs for a visually rich experience.',
        note: 'You can add as many Collections as you’d like to in this layout.',
        detailImage: "",
        icon: "",
        dimensions: '193 * 135 px',
        data: {
          columns: [{
            width: 2,
            section: {
              title: "Section 1",
              contents: [],
              entityType: 'COLLECTION',
              type: 'collections_carousel',
              layoutStyle: 'CAROUSEL',
              cardStyle: 'SMALL',
              smartFilter: 'MY_COLLECTIONS'
            }
          }]
        }
      },
      {
        name: 'Promoted Content',
        description: 'Spotlight your prime-time content and ensure it stands tall and strong.',
        note: 'We recommend you to choose a Collection of your choice you\'d like to promote.',
        detailImage: "",
        icon: "",
        dimensions: '',
        data: {
          columns: [{
            width: 2,
            section: {
              title: "",
              contents: [],
              type: 'promoted_content',
              entityType: 'COLLECTION',
              layoutStyle: 'PROMOTED_CONTENT',
              cardStyle: 'SMALL',
            }
          }]
        }
      },

      //Assets
      {
        name: 'Carousel',
        description: 'A carousel scroll of Assets with portrait thumbnails.',
        note: 'You may add as many Assets as you’d like to in this layout.',
        detailImage: "",
        icon: "",
        dimensions: '128 * 150 px',
        data: {
          columns: [{
            width: 2,
            section: {
              title: "Section 1",
              contents: [],
              type: 'assets_carousel',
              entityType: 'ASSET',
              layoutStyle: 'CAROUSEL',
              cardStyle: 'SMALL',
              smartFilter: 'MOST_VIEWED_ASSETS'
            }
          }]
        }
      },

      {
        name: 'Promoted Content',
        description: 'Spotlight your prime-time content and ensure it stands tall and strong',
        note: 'We recommend you to choose an Asset of your choice you\'d like to promote.',
        detailImage: "",
        icon: "",
        dimensions: '',
        data: {
          columns: [{
            width: 2,
            section: {
              title: "",
              contents: [],
              type: 'promoted_content',
              entityType: 'ASSET',
              layoutStyle: 'PROMOTED_CONTENT',
              cardStyle: 'SMALL',
            }
          }]
        }
      },

      {
        name: 'Metro Combination',
        description: 'One Asset is highlighted as an Info Card while the others are displayed as smaller thumbnails around it. Ideal for a group of Assets that are related.',
        detailImage: "",
        note: 'Recommended number of Assets to display in this section is 4.',
        icon: "",
        data: {
          columns: [{
            width: 2,
            section: {
              title: "Section 1",
              contents: [],
              type: 'metro_combination',
              entityType: 'ASSET',
              layoutStyle: 'METRO',
              cardStyle: 'SMALL',
              smartFilter: 'MOST_VIEWED_ASSETS'
            }
          }]
        }
      },
      {
        name: 'Info Cards',
        description: ' A descriptive snapshot of Assets with portrait thumbnails. Provides a helpful summary of the Assets and enables easy discovery.',
        note: 'Recommended number of Assets to display in each section is 3.',
        detailImage: "",
        icon: "",
        data: {
          columns: [{
            width: 1,
            section: {
              title: "Section 1",
              contents: [],
              type: 'assets_two_column_list',
              entityType: 'ASSET',
              layoutStyle: 'LIST',
              cardStyle: 'SMALL',
              smartFilter: 'MOST_VIEWED_ASSETS'
            } 
          }, {
            width: 1,
            section: {
              title: "Section 2",
              contents: [],
              type: 'assets_two_column_list',
              entityType: 'ASSET',
              layoutStyle: 'LIST',
              cardStyle: 'SMALL',
              smartFilter: 'MOST_VIEWED_ASSETS'
            }
          }]
        }
      },
    ]
};

